declare const window: Window & typeof globalThis & { AppleID: any };

const formatAppleUser = (userInfo: any, id_token: string): ISocialProfile => {
  const decodedIdToken = decodeJWTPayloads(id_token);

  return {
    provider_name: "apple",
    token_type: "id_token",
    id_token,
    full_name: `${userInfo?.name?.firstName || ""} ${userInfo?.name?.lastName || ""}`,
    email: userInfo?.user?.email || decodedIdToken.email,
  };
};

export function initAppleSdk() {
  const appleSignInAPI = document.createElement("script");

  appleSignInAPI.setAttribute("src", "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js");
  document.head.appendChild(appleSignInAPI);
}

export async function loginApple(): Promise<ISocialProfile> {
  const appConfig = useRuntimeConfig().public;
  const appleID = window.AppleID;

  const clientId = appConfig.APP_CUSTOMER.app_config.app_client_id_for_apple;
  const redirectURI = window.location.origin;
  const scope = "name email";
  const state = "your_state";

  appleID.auth.init({
    clientId,
    redirectURI,
    scope,
    state,
    usePopup: true,
  });

  return new Promise((resolve, reject) => {
    appleID.auth.signIn()
      .then((response: any) => {
        const profile = formatAppleUser(response.user, response.authorization.id_token);

        resolve(profile);
      })
      .catch((e: { error: string }) => {
        reject(new Error(e.error));
      });
  });
}
